// extracted by mini-css-extract-plugin
module.exports = {"root":"TiketcomForm_root__ioTgx","row":"TiketcomForm_row__2wC0p"};